import React, { useEffect } from "react";
import "./Toaster.css";
import { reactIcons } from "../../icons/reactIcons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { setSnackbarDetails } from "../../redux/AuthSlice";

interface ToasterProps {
  //   message: string;
  //   onClose: () => void;
  //   duration?: number; // default auto close time
}

const Toaster: React.FC<ToasterProps> = () => {
  const dispatch = useDispatch();
  const snackbarDetails = useSelector(
    (state: RootState) => state.Auth.snackbarDetails
  );

  useEffect(() => {
    if (snackbarDetails.type && snackbarDetails.message) {
      const timer = setTimeout(() => {
        dispatch(setSnackbarDetails({ status: "", message: "" }));
      }, 3000);

      return () => clearTimeout(timer); // cleanup
    }
  }, [snackbarDetails.type, snackbarDetails.message, dispatch]);

  const handleClose = () => {
    dispatch(setSnackbarDetails({ status: "", message: "" }));
  };

  return (
    <div className="toaster">
      {snackbarDetails.type !== "" && snackbarDetails.message !== "" && (
        <div
          className={`toaster-container ${
            snackbarDetails.type === "success" ? "success" : "fail"
          }`}
        >
          <div className="toaster-msgMain">
            <div className="toaster-icon">
              <reactIcons.checkMarkIcon />
            </div>
            <span className="toaster-message">{snackbarDetails?.message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Toaster;
